import { render, staticRenderFns } from "./formInput.vue?vue&type=template&id=0bd24588"
import script from "./formInput.vue?vue&type=script&lang=js"
export * from "./formInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports